class RegAuthBtn {
	constructor(btn) {
		this.btn = btn;
        this.formName = this.btn.getAttribute('data-param');
        regAuthObj[this.formName].addBtn(this.btn);
	}

    del(){
        regAuthObj[this.formName].removeBtn(this.btn);
    }
};

export {RegAuthBtn};


































